<script setup lang="ts">
import type { Flat } from '~/types/types'
import { useGhostStuff, useState } from '#imports'

const Flats = useState<Record<number, Flat>>('Flats')
const ghostStuff = useGhostStuff()
</script>

<template>
  <svg
    viewBox="0 0 1400 730"
  >
    <!-- <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name,  'ghost-element']"
      points="260.3 258.9 260.3 303 218.8 303.6 218.7 319.9 211 319.9 211 329.3 146.9 329.4 146.8 256.9 77.7 256.8 77.7 172.5 210.1 172.8 210.1 196.7 283 196.7 283 258.8 260.3 258.9"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name,  'ghost-element']"
      points="259.8 258.9 259.7 303 292.6 303.2 292.7 298.6 313.6 298.2 313.8 289.1 321.5 289.2 321.8 303.3 401.7 303.6 402.2 330.4 457.7 330.4 457.7 326.3 533.2 326.4 533.1 337.3 557 337.2 557 257 533.3 256.8 533.3 172.9 404.4 173 404.4 197 282.7 196.7 282.6 258.8 259.8 258.9"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name,  'ghost-element']"
      points="533.2 415.3 533.3 492 557 491.6 556.7 574.2 458.1 573.8 457.9 494 402.2 493.7 402.2 415.5 533.2 415.3"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name,  'ghost-element']"
      points="533.2 415.3 533.2 326.3 457.7 326.3 457.7 330.4 402.7 330.4 403 415.5 533.2 415.3"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name, 'ghost-element']"
      points="533.1 574.1 458.4 573.8 458.4 493.9 402.5 493.7 402.4 507.7 372.3 507.8 372.3 560.9 400.6 560.9 400.6 658.2 533.1 658.2 533.1 574.1"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name,  'ghost-element']"
      points="372.4 512.4 347.1 512.3 347 507.8 260.2 507.8 260.1 572.9 210.1 572.9 209.9 631.1 400.6 630.5 400.5 560.9 372.3 560.9 372.4 512.4"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name,  'ghost-element']"
      points="77.7 415.3 77.7 490.9 53.9 490.8 53.8 574.2 146.7 573.8 146.9 493.9 168.8 493.7 168.8 502.7 210.1 502.8 210.1 496.8 216.8 496.8 216.8 473.8 260.3 474 260.3 415.5 77.7 415.3"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name, 'ghost-element']"
      points="77.7 415.5 77.5 339.2 53.9 339.2 54 256.9 146.8 256.9 146.9 329.4 211 329.3 211 337.3 260 336.7 260.1 415.5 77.7 415.5"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name, 'ghost-element']"
      points="77.6 574.1 146.7 573.8 146.9 493.9 168.5 493.7 168.8 502.7 210.4 502.8 210.8 512.1 216.5 512.1 216.8 507.7 260.2 507.8 260.2 573 210.2 572.9 210.2 658.2 77.6 658.2 77.6 574.1"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name,  'ghost-element']"
      points="1140.4 258.9 1140.4 303 1181.9 303.6 1182 319.9 1189.8 319.9 1189.8 329.3 1253.8 329.4 1253.9 256.9 1323 256.8 1323 172.5 1190.6 172.8 1190.6 196.7 1117.8 196.7 1117.8 258.8 1140.4 258.9"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name,  'ghost-element']"
      points="1141 258.9 1141 303 1108.2 303.2 1108 298.6 1087.2 298.2 1087 289.1 1079.3 289.2 1078.9 303.3 999.1 303.6 998.6 330.4 943.1 330.4 943 326.3 867.5 326.4 867.6 337.3 843.8 337.2 843.8 257 867.4 256.8 867.4 172.9 996.4 173 996.4 197 1118 196.7 1118.2 258.8 1141 258.9"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name, 'ghost-element']"
      points="867.5 415.3 867.4 492 843.8 491.6 844.1 574.2 942.7 573.8 942.8 494 998.6 493.7 998.6 415.5 867.5 415.3"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name,  'ghost-element']"
      points="867.5 415.3 867.5 326.3 943.1 326.3 943.1 330.4 998.1 330.4 997.8 415.5 867.5 415.3"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name, 'ghost-element']"
      points="867.6 574.1 942.4 573.8 942.4 493.9 998.3 493.7 998.3 507.7 1028.4 507.8 1028.4 560.9 1000.2 560.9 1000.2 658.2 867.6 658.2 867.6 574.1"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name,  'ghost-element']"
      points="1028.3 512.4 1053.6 512.3 1053.7 507.8 1140.6 507.8 1140.6 572.9 1190.7 572.9 1190.9 631.1 1000.1 630.5 1000.2 560.9 1028.5 560.9 1028.3 512.4"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name,  'ghost-element']"
      points="1322.8 490.9 1323.2 339.2 1346.8 339.2 1346.7 256.9 1253.9 256.9 1253.8 329.4 1189.7 329.3 1189.8 337.3 1140.7 336.7 1140.7 474 1181.1 474.6 1181.9 507.6 1183.7 512.1 1189.6 512.1 1189.6 502.8 1231.6 502.7 1231.7 492.7 1253.9 492.8 1253.7 572.3 1346.6 571.9 1346.6 490.9 1322.8 490.9"
      @click="ghostStuff.openLink"
    />
    <polygon
      id="0"
      :class="['fill-ghost-'+Flats[0]?.status_name, 'ghost-element']"
      points="1323.1 572.3 1253.7 572.3 1253.6 492.7 1231.7 492.7 1231.6 502.7 1189.6 502.8 1189.6 512.1 1184.2 512.1 1183.9 507.7 1140.5 507.8 1140.5 573 1190.5 572.9 1190.5 658.2 1323.1 658.2 1323.1 572.3"
      @click="ghostStuff.openLink"
    /> -->
  </svg>
</template>
